{
  "de": {
    "modelPicker": {
      "hangarTitle": "Schiffe zum Hangar hinzufügen",
      "compareTitle": "Schiffe zum Vergleichen auswählen",
      "wishlistTitle": "Schiffe zur Wunschliste hinzufügen",
      "labels": {
        "search": "Nach Name oder Hersteller suchen",
        "results": "%{count} Schiffe",
        "selected": "%{count} ausgewählt"
      },
      "actions": {
        "resetFilters": "Filter zurücksetzen",
        "clearSelection": "Auswahl aufheben",
        "increase": "Weitere %{name} hinzufügen",
        "decrease": "Eine %{name} entfernen"
      },
      "badges": {
        "inHangar": "Im Hangar",
        "onWishlist": "Auf der Wunschliste",
        "comparing": "Im Vergleich"
      }
    }
  }
}
